import { useDefaultShifts } from './useDefaultShifts'
import { usePermissions } from './usePermissions'

interface Props {
  fromUnassigned?: boolean
}

const useVisibleDefaultShifts = ({ fromUnassigned = false }: Props) => {
  const [{ activeDefaultShifts, visibleDefaultShifts }] = useDefaultShifts()
  const [{ canCreateShiftsForEverybody, canCreateUnassignedShiftsForEverybody }] = usePermissions()

  const canCreateForEverybody = fromUnassigned
    ? canCreateUnassignedShiftsForEverybody
    : canCreateShiftsForEverybody

  return canCreateForEverybody ? activeDefaultShifts : visibleDefaultShifts
}

export { useVisibleDefaultShifts }
